export const INCREASE_LOADING_STATUS = "increaseLoadingStatus";
export const DECREASE_LOADING_STATUS = "decreaseLoadingStatus";
